import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 依存サービス一覧
export async function getOutsideEntryFormOptionDependServices(id: string) {
  try {
    const path = "outsideEntryFormOptionDependServices";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
